module.exports = __webpack_public_path__ + "img/xlsx.0d02aded.svg";